import { ref } from 'vue';
import { groupCollectionsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';

export const useGroupCollectionsGroupsCount = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;

    // [groupCollectionId]: groupsCount
    // undefined = loading
    // null = not found
    const groupCounts = ref({});

    const fetching = ref(false);

    /**
     * @param {number[]} groupCollectionIds
     */
    const fetchGroupCollectionsGroupsCount = async (groupCollectionIds) => {
        // remove existing ids to avoid computing them again
        groupCollectionIds = groupCollectionIds.filter((groupCollectionId) => !groupCounts.value[groupCollectionId]);

        if (!groupCollectionIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchGroupCollectionsGroupsCount(groupCollectionIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            const response = await groupCollectionsClient.getGroupCollectionsGroupCounts(teamId, {
                group_collection_ids: groupCollectionIds,
            });

            groupCollectionIds.forEach((groupCollectionId) => {
                groupCounts.value[groupCollectionId] = response.data.counts[groupCollectionId] ?? 0;
            });
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchGroupCollectionsGroupsCount,
        groupCounts,
    };
});
